import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { BodyText } from 'styling/Typography'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { MetricCard } from 'components/ui/MetricCard/MetricCard'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { NoData } from 'components/NoData'
import { tokens } from 'styling/tokens'
import { IMaterialDelivery } from 'types/materialReceipt.interface'
import { fmt, taskForStation } from './materialReceiptData'
import { MaterialReceiptPage } from './MaterialReceiptShell'
import { KpiGrid, TaskHint } from './MaterialReceipt.styled'

export const MaterialMyWork = () => {
  const navigate = useNavigate()
  const { deliveries } = useSelector((s: RootState) => s.materialReceipt)

  const queue = deliveries.filter((d) => taskForStation(d, 'LAB')?.kind === 'assay')
  const assayed = deliveries.filter((d) => d.prov.assay)
  const awaitingWeigh = deliveries.filter((d) => d.gross == null)

  const columns: IHonestTableColumn<IMaterialDelivery>[] = [
    { id: 'ticket', header: 'Ticket', cell: (d) => <BodyText weight='600' style={{ margin: 0 }}>{d.id}</BodyText> },
    { id: 'supplier', header: 'Supplier', cell: (d) => d.supplier },
    { id: 'source', header: 'Source', cell: (d) => d.source || '—' },
    { id: 'gross', header: 'Gross', cell: (d) => (d.gross != null ? `${fmt(d.gross)} t` : '—') },
    { id: 'task', header: 'Your task', cell: () => <TaskHint $active>Enter assay</TaskHint> },
  ]

  return (
    <MaterialReceiptPage title='My work' subtitle='Lab assay queue'>
      {() => (
        <>
          <KpiGrid>
            <MetricCard
              label='Awaiting your assay'
              value={String(queue.length)}
              accentColor={tokens.accent.base}
              trailing={queue.length ? <StatusPill status='warning'>action</StatusPill> : <StatusPill status='success'>clear</StatusPill>}
            />
            <MetricCard label='Assayed (all time)' value={String(assayed.length)} />
            <MetricCard label='Not yet weighed' value={String(awaitingWeigh.length)} trailing={<StatusPill status='info'>weighbridge</StatusPill>} />
          </KpiGrid>

          {queue.length ? (
            <HonestTable
              columns={columns}
              data={queue}
              keyField='id'
              onClick={(d) => navigate(`/material-receipt/ticket/${d.id}`)}
            />
          ) : (
            <NoData text='No samples waiting on the lab right now.' />
          )}
        </>
      )}
    </MaterialReceiptPage>
  )
}
